const features = [
  {
    icon: 'ri-flashlight-line',
    title: '秒开播放',
    desc: '采用先进的不缓冲秒开播放技术，点击即播无需等待，为您带来极速流畅的观影体验。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量片库',
    desc: '汇聚电视剧全集、电影大全、综艺节目、热门剧集与经典影片，10000+内容一网打尽。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '支持720P至4K多种清晰度，根据设备和网络智能匹配最佳画质，让每一帧都清晰动人。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '片库每日持续更新200+内容，热播剧集第一时间同步，不错过任何一部好片好剧。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步',
    desc: '手机、平板、电脑、电视全平台覆盖，多设备无缝续播，随时随地畅享观影。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="relative py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-50 mb-3">平台优势</h2>
          <p className="text-foreground-500 max-w-lg mx-auto">选择大师兄影视，享受高品质的在线观影服务</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="group bg-background-200/50 rounded-xl p-6 border border-background-200/60 hover:border-primary-500/20 transition-all duration-200 cursor-pointer text-center"
            >
              <span className="inline-flex w-12 h-12 items-center justify-center rounded-xl bg-primary-500/15 text-primary-400 mb-4 group-hover:scale-110 transition-transform">
                <i className={`${feat.icon} text-xl`}></i>
              </span>
              <h3 className="text-foreground-100 font-semibold text-sm md:text-base mb-2">{feat.title}</h3>
              <p className="text-foreground-500 text-xs leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}